import actions from "@/store/actions"
import loadding from "@/store/modules/loadding"
import login from "@/store/modules/login"
import mutations from "@/store/mutations"
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// let date = new Date()
// let day = date.getDate()
// let time
// //mouth 是从 0-11 过次月三号才能显示上一个月数据
// if (date.getMonth() == 0) {
//   if (day < 15) {
//     time = `${date.getFullYear() - 1}-11`
//   } else {
//     time = `${date.getFullYear() - 1}-12`
//   }
// } else {
//   if (day < 15) {
//     if (date.getMonth() <= 1) {
//       time = `${date.getFullYear() - 1}-${12 - (1 - date.getMonth())}`
//     } else {
//       time = `${date.getFullYear()}-${date.getMonth() - 1}`
//     }
//   } else {
//     // if (date.getMonth() == 0) {
//     //   time = `${date.getFullYear() - 1}-12`
//     // } else {
//     //   time = `${date.getFullYear()}-${date.getMonth()}`
//     // }
//     time = `${date.getFullYear()}-${date.getMonth()}`
//   }
// }
const state = {
  city: '全国',
  month: '1',
  time: '',
  realTime: '',
  showTipAlert: false,
  navigation: {
    name: '', //全局导航的名字
  }

}


const modules = {
  loadding,
  login
}

// };
// const actions = {
//   /**
//    * 修改公共时间
//    * */
//   changeTime({ commit }, reqTime) {
//     commit("CHANGE_TIME", reqTime)
//   },
//   /**
//    * 修改公共月数
//    * */
//   changeMonth({ commit }, reqMonth) {
//     commit("CHANGE_MONTH", reqMonth)
//   },
//   /***
//    * 修改公共城市
//    * */
//   changeCity({ commit }, reqCity) {
//     commit("CHANGE_CITY", reqCity);
//   },
//   /**
//    *  修改动画加载时长和顺序
//    * @param {*} param
//    * @param {*} infor 传入导航信息
//    */
//   changeLoadding({ commit }, infor) {
//     commit('CHANGE_LOADDING',infor)
//   }
// };
const store = new Vuex.Store({
  state,
  mutations,
  actions,
  modules
})

export default store


